import React from 'react';

export const SquareBoxIcon = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="xMidYMid"
  >
    <g fill="#2E3B4E">
      <path d="M212.65112,5.1534007e-15 L42.6694771,5.1534007e-15 C19.1066886,5.1534007e-15 0,19.1008864 0,42.6694771 L0,212.65112 C0,236.219711 19.1066886,255.320597 42.6694771,255.320597 L212.65112,255.320597 C236.219711,255.320597 255.320597,236.219711 255.320597,212.65112 L255.320597,42.6694771 C255.326399,19.1008864 236.225513,0 212.65112,0 L212.65112,5.1534007e-15 Z M208.90289,195.447557 C208.90289,202.885995 202.87439,208.908692 195.441755,208.908692 L59.907853,208.908692 C52.4694155,208.908692 46.4409158,202.885995 46.4409158,195.447557 L46.4409158,59.907853 C46.4409158,52.4694155 52.4694155,46.4409158 59.907853,46.4409158 L195.441755,46.4409158 C202.87439,46.4409158 208.90289,52.4694155 208.90289,59.907853 L208.90289,195.447557 L208.90289,195.447557 Z" />
      <path d="M100.569764,162.479381 C96.2993353,162.479381 92.8412161,158.998053 92.8412161,154.710217 L92.8412161,100.61038 C92.8412161,96.3225441 96.2993353,92.8412161 100.569764,92.8412161 L154.750833,92.8412161 C159.032866,92.8412161 162.479381,96.3225441 162.479381,100.61038 L162.479381,154.710217 C162.479381,158.998053 159.032866,162.479381 154.750833,162.479381 L100.569764,162.479381 L100.569764,162.479381 Z" />
    </g>
  </svg>
);

export const CircleBoxIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={20}
    height={20}
    viewBox="0 0 1080 1080"
    xmlSpace="preserve"
  >
    <defs />
    <g transform="matrix(1 0 0 1 540 540)" id="9ddd4acb-b29a-40f7-bc77-5ddec6911c8b">
      <rect
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeDashoffset: 0,
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          fill: 'rgb(0,0,0)',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        vectorEffect="non-scaling-stroke"
        x={-540}
        y={-540}
        rx={0}
        ry={0}
        width={1080}
        height={1080}
      />
    </g>
    <g transform="matrix(1 0 0 1 540 540)" id="7b41b72e-b12f-4ec9-a672-4b051f25da86" />
    <g transform="matrix(10.83 0 0 10.83 540 540)" id="b0991fea-4a01-4df3-8e02-5283c9b7cee2">
      <rect
        style={{
          stroke: 'rgb(0,0,0)',
          strokeWidth: 0,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeDashoffset: 0,
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          fill: 'rgb(255,255,255)',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        vectorEffect="non-scaling-stroke"
        x={-33.0835}
        y={-33.0835}
        rx={0}
        ry={0}
        width={66.167}
        height={66.167}
      />
    </g>
    <g transform="matrix(6.17 0 0 6.17 540 540)" id="88008a2b-71a5-47f7-bdbe-c4234b43997d">
      <circle
        style={{
          stroke: 'rgb(0,0,0)',
          strokeWidth: 0,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeDashoffset: 0,
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          fill: 'rgb(0,0,0)',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        vectorEffect="non-scaling-stroke"
        cx={0}
        cy={0}
        r={35}
      />
    </g>
  </svg>
);
